<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25" style="height: 50px;" [svgIcon]="smsIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid p-2" [formGroup]="smsSettingsForm">
        <div class="row">
            <mat-form-field class="w-100 no-margin" appearance="outline">
                <mat-label>Set a default after-call text message</mat-label>
                <input matInput placeholder="Set your custom after-call text message" class="disabled"
                    [readonly]="messageChoices.length > 0" formControlName="smsContent">
                <mat-hint>Set a text message to be sent after the call is completed</mat-hint>
            </mat-form-field>
        </div>
        <mat-divider></mat-divider>
        <app-minutes-time-unit-mapping class="row mt-5" (minutesValueChanged)="onMinutesValueChange($event)"
            [minutesValue]="confirmationDelay"
            [labelValue]="appMinuteTimeUnitMappingLabel"></app-minutes-time-unit-mapping>
        <div class="row">
            <mat-form-field class="w-100 no-margin" appearance="outline">
                <mat-label>Define when you would like your sms to be sent</mat-label>
                <input matInput placeholder="Define when you would like your sms to be sent" class="disabled"
                    formControlName="activeCondition">
                <mat-hint>(Optional) Define when you would like your sms to be sent</mat-hint>
            </mat-form-field>
        </div>
        <div class="row">
            <div class="d-inline-flex">
                <mat-checkbox formControlName="active" class="m-0">Active</mat-checkbox>
                <mat-checkbox formControlName="sendToCaller" class="m-0">Send to caller</mat-checkbox>
                <mat-checkbox formControlName="forceUserInfoPush">Force Push</mat-checkbox>
                <mat-checkbox formControlName="confirmUserInfo">Confirm user collected
                    information</mat-checkbox>
            </div>
        </div>
        <ng-container formArrayName="messageChoices">
            <div class="row" *ngFor="let choice of messageChoices.controls;let i = index;">
                <mat-divider class="mb-4 mt-2"></mat-divider>
                <ng-container [formGroup]="choice">
                    <mat-form-field class="w-100 no-margin" appearance="outline">
                        <mat-label>Set your custom after-call text message</mat-label>
                        <input matInput placeholder="Set your custom after-call text message" formControlName="content">
                        <button matSuffix mat-icon-button aria-label="Clear" (click)="onRemoveField(i)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field class="w-100 no-margin" appearance="outline">
                        <mat-label>Set the condition for this sms to be sent </mat-label>
                        <input matInput placeholder="Set your custom after-call text message"
                            formControlName="condition">
                    </mat-form-field>
                </ng-container>
            </div>
        </ng-container>
        <div class="row mt-5">
            <div class="col-12 d-flex justify-content-center">
                <button type="button" mat-fab (click)="onAddField()" class="bg-light text-dark me-2"
                    aria-label="Example icon button with a delete icon">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <p class="text-center">Add sms messages to be sent based on certain conditions</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" [disabled]="isLoading" color="warn">Close</button>
    <button mat-raised-button class="w-25" [disabled]="isLoading|| !smsSettingsForm.valid" (click)="onSubmit()"
        color="primary">
        <span *ngIf="!isLoading">
            Save
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>